import {Task2, TaskBoardCard, TaskBoardColumn} from "../../api/Tasks2";
import {Button, DialogTitle, IconButton} from "@mui/material";
import {Dialog2} from "../../misc/Dialog2";
import {Close} from "@mui/icons-material";
import {useCallback, useEffect, useState} from "react";
import {useAsync2, useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../api/API";
import {TaskEvents} from "./TaskEvents";
import {grey} from "@mui/material/colors";
import {ViewTaskHeader} from "./viewTask/ViewTaskHeader";
import {TaskTitle} from "./viewTask/TaskTitle";
import {Task2CardProvider} from "./viewTask/Task2CardContext";
import {Description} from "./Description";
import useWindowSize from "react-use/lib/useWindowSize";
import {useConfirm} from "../../misc/Confirm";
import {useSnackbar} from "../../misc/Snackbar";
import {EditProductDialog} from "../project/shopdrawing/hardware/EditProduct";

export function ViewTask(props: {
    id: number;
    card?: TaskBoardCard;
    column?: TaskBoardColumn;
    onClose(): void;
}) {

    const taskDetail = useAsync2(input => api.tasks2.get(input),
        {id: props.id},
        [props.id]);

    const [valueExt, setValueExt] = useState<Task2>();

    const cardObj = taskDetail.result;
    useEffect(() => {
        if(!cardObj) return;
        setValueExt(cardObj);
    }, [cardObj]);

    const upsertRaw = useCallback(async (input) => {
        const obj = await api.tasks2.update(input);
        setValueExt(obj);
    }, []);

    const upsert = useAsyncAction(upsertRaw, [upsertRaw]);
    const win = useWindowSize();
    const confirm = useConfirm();
    const snack = useSnackbar();
    const [editProduct, setEditProduct] = useState<number>();

    return (
        <Dialog2 open onClose={props.onClose} maxWidth="md" fullWidth>
            <Task2CardProvider onReload={() => taskDetail.reload()}>
                <DialogTitle style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                    <div style={{
                        flex: 1,
                    }}>
                        <TaskTitle value={valueExt?.title || ""} onChange={(v) => upsertRaw(Object.assign({}, valueExt, {
                            title: v,
                        }))} />
                    </div>
                    <IconButton onClick={props.onClose}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                    gap: 8,
                    maxHeight: win.height * 0.75,
                    overflow: "auto",
                    backgroundColor: grey["200"],
                }}>
                    <div style={{
                        flex: 1,
                        overflow: "auto",
                        minWidth: 450,
                        paddingRight: 8,
                    }}>
                        <ViewTaskHeader
                            card={props.card}
                            column={props.column}
                            onClose={props.onClose}
                            valueExt={valueExt}
                            onUpdate={(v) => upsertRaw(Object.assign({}, v, {
                                events: null,
                                watchers: null,
                                assignment: null,
                            }))}
                        />
                        {upsert.LoadingElement}
                        <Description
                            value={valueExt?.description || ""}
                            onUpdate={(v) => upsertRaw(Object.assign({}, valueExt, {
                                description: v,
                                events: null,
                                watchers: null,
                                assignment: null,
                            }))}
                        />
                        {taskDetail.LoadingOrErrorElement}
                        <TaskEvents
                            task2={props.id}
                            value={valueExt?.events || []}
                            onUpdate={() => taskDetail.reload()}
                        />
                        <div style={{height: 200}} />
                    </div>
                    {props.card && <div style={{
                        padding: 16,
                        display: "flex",
                        flexDirection: "row",
                        gap: 8,
                    }}>
                        <Button size="small" onClick={async () => {
                            if(!props.card) return;
                            const card = props.card;

                            const ok = await confirm.confirm("Are you sure you want to archive this card?");
                            if(!ok) return;

                            try {
                                snack.loading()
                                await api.tasks2.updateCard(Object.assign({}, card, {
                                    archived: true,
                                }));
                                props.onClose();
                                snack.success("Card archived");
                            } catch (e: any) {
                                snack.error(e.toString());
                            }
                        }} color="error" variant="outlined">Archive Card</Button>

                        {props.card.task2Obj.meta.product &&
                            <Button
                                size="small" variant="outlined"
                                onClick={() => setEditProduct(props.card?.task2Obj.meta.product)}>
                            Edit Product
                        </Button>}

                        {editProduct && <EditProductDialog
                            id={editProduct} onClose={() => setEditProduct(undefined)}
                            dimensionScreen={true}
                            mode="hardware"
                        />}
                    </div>}
                </div>
            </Task2CardProvider>
        </Dialog2>
    )
}

